export default __webpack_public_path__ + "static/media/baby-21.83c019a4.svg";